const React = require('react');


module.exports = ({
  label,
  value,
  children,
  ...props
}) => {
  return (
    <div {...props}>
      <div className="f12 fw4 lh18 lts0em c8E8EA1">{label}</div>
      <div
        className="mt5 c2 f12 fw7 lh18 lts0em hmin32 layoutRow fhaS fvaS break"
      >{value || children || null}</div>
    </div>
  );
};
